import React, {Fragment} from "react";
import {Form, FormListener} from "../form/Form";
import {KycStatus, MultiFactorAuthStatus, User, UserAttributeDefinition} from "../../http/protocol";
import {FormGroup} from "../form/FormGroup";
import {FormInput, FormMap} from "../form/FormInput";
import {Submit} from "../form/Submit";
import {getContainer} from "../../ioc/IOCSetup";
import {RouteComponentProps, withRouter} from "react-router";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {LoadingViewState, RouterView} from "../RouterView";
import {Validators} from "../form/Validators";
import {UserService} from "../../services/UserService";
import {SelectInput} from "../form/SelectInput";
import { getStore } from "../../RootReducer";
import { PermissionCategory } from "../../services/MenuService";
import { UserAuthenticationService } from "../../services/UserAuthenticationService";
import { UserAttributeService } from "../../services/UserAttributeService";
import { Button } from "react-bootstrap";
import { ConfirmModal } from "../../util/ConfirmModal";

interface State extends LoadingViewState {
    user? : User;
    validationMap? : any;
    groupPermissionAccountAttributes?: boolean;
    modalAttribute?: boolean;
    userAttributeDefinitions?:UserAttributeDefinition[];
    selectedAttribute?: string;
}

interface Props extends RouteComponentProps {

}

export class EditUserView extends RouterView<Props,State> implements FormListener<User>{

    service : UserService;
    userAuthenticationService: UserAuthenticationService;
    userAttributeService: UserAttributeService;
    constructor(props : Props){
        super(props);
        this.service = getContainer().getUserService();
        this.userAuthenticationService = getContainer().getUserAuthenticationService();
        this.userAttributeService = getContainer().getUserAttributeService();
        this.state = { user : {}, validationMap : {}, loading : true, modalAttribute:false, userAttributeDefinitions: []};
    }

    loadContent() : Promise<any> | undefined {
        var id = (this.props.match.params as any).id;
        return this.service.getEntity(id).then((a : User) => {
            this.setState({ user : a});
            this.permissionAccountAttributes();
            this.getAttributesKey();
        })

    }

    permissionAccountAttributes(){
        this.userAuthenticationService.getGroupPermissions().then(x=>{
            let value = x["ACCOUNT_ATTRIBUTES"];
            if(value===undefined || value===false){
                this.setState({groupPermissionAccountAttributes:value});
            }else{
                this.setState({groupPermissionAccountAttributes:true});
            }
        })
    }

    getAttributesKey(){
        const data :string[] = [];
        this.userAttributeService.list({}).then(x=>{
            this.setState({userAttributeDefinitions:x.items})
        })
    }

    componentDidUpdate(prevProps : RouteComponentProps, prevState : any) {
        if((this.props.match.params as any).id !== (prevProps.match.params as any).id) {
            this.refreshContent();
        } else {
            super.componentDidUpdate(prevProps, prevState);
        }
    }

    onSubmit():Promise<any> {
        if(!this.state.user) {
           return Promise.reject("Unable to save attribute");
        }
        return this.service.save(this.state.user).then( (a : User) => {
            this.setState({ user : a });
            
        }).catch(err=>{
            throw Error("Unable to create/save user");
        });
        
    }

    handleSubmit():Promise<any> {
        if(!this.state.user) {
           return Promise.reject("Unable to save attribute");
        }
        return this.service.setAttributes(this.state.user.id!,this.state.user.attributes!).then( (a : User) => {
            this.setState({ user : a, modalAttribute:true});
        }).catch(err=>{
            throw Error("Unable to create/save user");
        });
    }

    onSubmitError(){}

    formDidUpdate(formModel:UserAttributeDefinition, validationMap : any) {
        this.setState({ user : formModel, validationMap : validationMap});
    }


    getTitle() : string {
        return "Edit User";
    }

    addAttribute(key:string,value:string) {
        if(!this.state.user) return;
        let kvp : any= {};
        kvp[key] = value;
        let attributes = Object.assign({}, this.state.user.attributes, kvp);
        this.setState({ user : Object.assign({}, this.state.user , { attributes : attributes})})
    }
    removeAttribute(key : string) {
        if(!this.state.user) return;
        let attributes = Object.assign({}, this.state.user.attributes);
        delete attributes[key];
        this.setState({ user : Object.assign({}, this.state.user , { attributes : attributes})})
    }

    selectAttribute(key: string | undefined){
        if(!this.state.user) return;
        this.setState({ selectedAttribute: key})
    }

    hasPermission(category:PermissionCategory, writeAccess:boolean) {
        try {
            var permissions = getStore().getState().user.permissions;
            console.log("Permissions ", getStore().getState().user.permissions);
            console.log("writeAccess ", writeAccess);
            console.log("Permission["+category+"] ", permissions && permissions[category+""]);

            if (writeAccess && permissions && permissions[category+""] && permissions[category+""] === true ) {
                return true;
            } else if (!writeAccess && permissions && permissions[category+""]) {
                return true;
            } else {
                return false;
            }
            
        } catch (e) {
            console.error("Failed to check permission ", e);
            return false;
        }
    }

    renderMultiFactorAuthentication() {
        
        

        if (this.state.user && this.state.user.mfaStatus === MultiFactorAuthStatus.ENABLED) {
            if (this.hasPermission(PermissionCategory.USER_AUTHENTICATION, true)) {
                return (<button className="btn btn-danger" type="button" onClick={this.on2FADisableClick.bind(this)}>Disable 2FA</button>)
            } else {
                return (<button className="btn btn-secondary" type="button" disabled>Disable 2FA</button>)
            }
        } else {
            return (<button className="btn btn-secondary" type="button" disabled>2FA Not Set</button>)
        }
    }

    on2FADisableClick() {
        this.service.disableUser2FA(this.state.user && this.state.user.id).then(() => {
            this.refreshContent();
        });
    }

    renderContent() {
        if(!this.state.user) {
            return <span></span>
        }

        const userAttributeKeys = this.state.userAttributeDefinitions.map((def: UserAttributeDefinition)=> def.attributeKey );
        const selectedAttributeDefinition : UserAttributeDefinition | undefined = this.state.userAttributeDefinitions.find(def =>{ 
            return def.attributeKey === this.state.selectedAttribute
        });
        const selectedAttributeValues : string[] = selectedAttributeDefinition && selectedAttributeDefinition.options && selectedAttributeDefinition.options.split(",");
        const selectedAttributeDefaultValue : string | undefined = selectedAttributeDefinition && selectedAttributeDefinition.defaultValue;
        
        return (

            <Fragment>
                    <Form className="form-horizontal" formListener={this} modelObject={this.state.user} validationMap={this.state.validationMap}>
                        <div className={"card"}>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <FormSubmitError />
                                        <FormSubmitSuccess text="User Attribute was updated successfully"/>

                                        <FormGroup className="form-group mb-3" model="email">
                                            <label>E-mail</label>
                                            <FormInput className="form-control" model="email" type="text" validators={[Validators.required()]}/>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group mb-3" model="country">
                                            <label>Country Code</label>
                                            <FormInput className="form-control" model="country" type="text"/>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>
                                        
                                        <FormGroup className="form-group mb-3" model="createdRemoteAddress">
                                            <label>Created Remote Address</label>
                                            <FormInput className="form-control" model="createdRemoteAddress" type="text"/>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>

                                        <div className="custom-control custom-checkbox">
                                            <FormInput className="custom-control-input"  id={"blocked"} model="blocked" type="checkbox"/>
                                            <label htmlFor={"blocked"} className={"custom-control-label"}>Blocked</label>
                                        </div>

                                        <div className="hr-line-dashed" style={{display:"none"}}></div>


                                        <div className="custom-control custom-checkbox" style={{display:"none"}}>
                                            <FormInput className="custom-control-input" model="kycVerified" id={"kycVerified"} type="checkbox"/>
                                            <label htmlFor={"kycVerified"} className={"custom-control-label"}>KYC Verified</label>
                                        </div>

                                        <div className="hr-line-dashed"></div>

                                        <div className="custom-control custom-checkbox">
                                            <FormInput className="custom-control-input" model="emailVerified" id={"emailVerified"} type="checkbox"/>
                                            <label htmlFor={"emailVerified"} className={"custom-control-label"}>Email Verified</label>
                                        </div>

                                        <div className="hr-line-dashed"></div>

                                        <div className="custom-control custom-checkbox">
                                            <FormInput className="custom-control-input" model="creditEnabled" id={"creditEnabled"} type="checkbox"/>
                                            <label htmlFor={"creditEnabled"} className={"custom-control-label"}>Credit Enabled</label>
                                        </div>
                                        <div className="hr-line-dashed"></div>
                                        <div className="custom-control custom-checkbox">
                                            <FormInput className="custom-control-input" model="termsAccepted" id={"termsAccepted"} type="checkbox"/>
                                            <label htmlFor={"termsAccepted"} className={"custom-control-label"}>Terms Accepted</label>
                                        </div>

                                        <div className="hr-line-dashed" style={{display:"none"}}></div>
                                        <FormGroup className="form-group mb-3" model="kycStatus" style={{display:"none"}}>
                                            <label>KYC Status</label>
                                            <SelectInput values={[KycStatus.NOT_STARTED, KycStatus.PENDING, KycStatus.REVIEW_NEEDED, KycStatus.VERIFIED, KycStatus.REJECTED]} className="form-control" model="kycStatus" type="text" validators={[Validators.required()]}/>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group mb-3" model="kycStatus">
                                            <label>Two-Factor Authentication</label>
                                            <br/>
                                            {this.renderMultiFactorAuthentication()}
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>


                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="ibox float-e-margins">
                                            <div className="ibox-content">
                                                <div className="ibox-title">
                                                    <h5>Actions</h5>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-10 col-sm-offset-2">
                                                        <Submit className="btn btn-primary waves-effect waves-light">Save User</Submit>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                    {this.state.groupPermissionAccountAttributes===true && (
                        <Form className="form-horizontal" formListener={this} modelObject={this.state.user} validationMap={this.state.validationMap}>
                            <div className="card-box">
                                <div className="row">
                                    <div className="col-lg-12">
                                        
                                        <h5>Account Attributes</h5>
      
                                        <FormMap mapModel="attributes"
                                            removeAttribute={(key? : string)=> key && this.removeAttribute(key)}
                                            addAttribute={(key?, value?)=> key && value && this.addAttribute(key,value)}
                                            keyOptions={userAttributeKeys}
                                            valueOptions={selectedAttributeValues}
                                            defaultValue={selectedAttributeDefaultValue}
                                            onFormUpdate={(key) => this.selectAttribute(key)}
                                            optional={true}
                                        />
                                        <div className="hr-line-dashed"></div>
                                    </div>
                                </div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="ibox float-e-margins">
                                                <div className="ibox-content">
                                                    <div className="ibox-title">
                                                        <h5>Actions</h5>
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="col-sm-10 col-sm-offset-2">
                                                            <Button onClick={()=>this.handleSubmit()}   className={"btn btn-primary waves-effect waves-light"}>Save User</Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <ConfirmModal
                                    show={this.state.modalAttribute}
                                    okLabel={"Close"}
                                    heading={"OMG, we did it!"}
                                    description={"User Attribute was updated successfully"}
                                    okClassName={"btn btn-primary"}
                                    hideCancelButton={true}
                                    onOk={()=>{
                                        this.setState({modalAttribute: false});
                                    }}
                                    onCancel={()=>{ this.setState({modalAttribute: false})}}
                                    descriptionAlert={true}
                                />
                        </Form>
                    )}
            </Fragment>
        )
    }

}

export default withRouter(EditUserView);